// extracted by mini-css-extract-plugin
export default {"container":"VideoUploadForm_container__DKmdP","form":"VideoUploadForm_form__pABMI","message":"VideoUploadForm_message__m+-9w"};